import React from 'react'
import SVGIcon from '../helpers/icons'

function TipContentImage ({closeLabel = 'OK', settings, closemodal}) {
  return (
    <div className={'tip-modal-content image'}>
      <img src={settings.image} alt=""/>
      <button onClick={closemodal} aria-label={closeLabel} className={'close-button'}>
        <SVGIcon type={'close'} fill={'#FFF'} className={'close-button__icon'}/>
      </button>
    </div>
  )
}

export default TipContentImage